import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../pages/home'

import SummaryIndex from '../pages/homePage/apiPages/summaryIndex'
import DocumentIndex from '../pages/homePage/apiPages/documentIndex'
import UserinfoIndex from '../pages/homePage/apiPages/userinfoIndex'
import LoginPage from '../pages/homePage/loginPage'

Vue.use(VueRouter)

const routes = [
  {
    path: '/loginPage',
    name: 'LoginPage',
    component: LoginPage,
    meta: {
      auth: false
    }
  },
  {
    path: '/',
    component: Home,
    meta: {
      auth: false
    },
    children: [
      {
        path: '/',
        name: 'SummaryIndex',
        component: SummaryIndex,
        meta: {
          auth: false
        }
      },
      {
        path: '/documentIndex',
        name: 'DocumentIndex',
        component: DocumentIndex,
        meta: {
          auth: true
        }
      },
      {
        path: '/userinfoIndex',
        name: 'UserinfoIndex',
        component: UserinfoIndex,
        meta: {
          auth: true
        }
      },
    ]
  }
]
// 防止连续点击多次路由报错
const routerPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(err => err)
}

const router = new VueRouter({
  // mode: 'history', // 去掉url中的#
  routes
})

export default router
